import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private httpService: HttpService) { }
  ngemail =""; //"cedriccefc2002@gmail.com";
  ngpassword ="";// "sp1234";
  ngrememberMe = true;
  loginMessage = "";
  ngOnInit() {

  }
  async submitForm(form: any) {
    try {
      await this.httpService.Login(
        this.ngemail,
        this.ngpassword,
        this.ngrememberMe
      );
    }
    catch(erro)
    {
      this.loginMessage = erro;
    }
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/login/login.component.ts